import React from 'react';
import { Avatar, Card, Grid, Skeleton, Stack } from '@mui/material';
import { QueryObserverResult } from '@tanstack/react-query';
import { InfluencerName } from 'components';
import { InfluencerTypes, NegotiationTypes } from 'api';
import getSocialNetworkFromChannel from 'helpers/getSocialNetworkFromChannel';
import Actions from './Actions';
import InfoRow from './InfoRow';

interface Props {
  negotiation: NegotiationTypes.ItemData;
  refetch: () => Promise<QueryObserverResult>;
  inline?: boolean;
  influencer?: InfluencerTypes.ItemExtended;
}

const Header = (props: Props): JSX.Element => {
  const { negotiation, refetch, inline, influencer } = props;

  if (inline) {
    return (
      <Grid
        container
        columnGap={2}
        alignItems="center"
        wrap="nowrap"
        sx={{ p: 2 }}
      >
        <Grid item>
          {influencer ? (
            <Avatar
              src={influencer.profile_picture_url}
              sx={{ width: '100px', height: '100px' }}
            />
          ) : (
            <Skeleton
              variant="circular"
              sx={{ width: '100px', height: '100px' }}
            />
          )}
        </Grid>
        <Grid item sx={{ flexGrow: 1 }}>
          <Stack rowGap={2}>
            {influencer ? (
              <InfluencerName
                link
                data={influencer}
                activeNetwork={getSocialNetworkFromChannel(negotiation.channel)}
                TypographyProps={{ variant: 'h4' }}
              />
            ) : (
              <Skeleton variant="text" />
            )}
            <InfoRow negotiation={negotiation} />
          </Stack>
        </Grid>
      </Grid>
    );
  }

  return (
    <Card sx={{ p: 3 }}>
      <Grid container columnGap={4} alignItems="center">
        <Grid item>
          {influencer ? (
            <Avatar
              src={influencer.profile_picture_url}
              sx={{ width: '100px', height: '100px' }}
            />
          ) : (
            <Skeleton
              variant="circular"
              sx={{ width: '100px', height: '100px' }}
            />
          )}
        </Grid>
        <Grid item sx={{ flexGrow: 1 }}>
          <Grid container columnGap={2} alignItems="center" mb={3}>
            <Grid item sx={{ flexGrow: 1 }}>
              {influencer ? (
                <InfluencerName
                  link
                  data={influencer}
                  activeNetwork={getSocialNetworkFromChannel(
                    negotiation.channel,
                  )}
                  TypographyProps={{ variant: 'h4' }}
                />
              ) : (
                <Skeleton variant="text" />
              )}
            </Grid>
            <Grid item>
              <Actions negotiation={negotiation} refetch={refetch} />
            </Grid>
          </Grid>
          <InfoRow negotiation={negotiation} />
        </Grid>
      </Grid>
    </Card>
  );
};

export default Header;
